import React from 'react';
import ButtonCreate from '../../components/actions/ButtonCreate';
import ButtonUser from '../../components/actions/ButtonUser';

import { Dashboard } from '../../components/navigation/Dashboard';
import { MySurveys } from '../../components/navigation/MySurveys';
import { TeamMenu } from '../../components/navigation/TeamMenu';
import { Pricing } from '../../components/navigation/Pricing';

import { UserMenu } from '../../components/user-menu';
import { InfoMenu } from '../../components/info-menu';

import { Variant } from '../types';

const variant: Variant = {
  brand: 'Momentive',
  menu: [
    <Dashboard key="menu-dashboard" />,
    <MySurveys key="menu-home" />,
    <TeamMenu key="menu-team" />,
    <Pricing key="menu-pricing" />,
  ],
  actions: [
    <ButtonUser key="action-user" />,
    <ButtonCreate key="action-create" />,
  ],
  info: [<InfoMenu />],
  user: [<UserMenu />],
  homePage: '/',
};

export default variant;
